import { UtensilsCrossed, Music, BookOpen, Coffee, TreePine, Star, HeartHandshake } from 'lucide-react'

// Single source of truth for event-type UI data.
// Colors mirror packages/shared/src/event-types.ts exactly.
export const EVENT_TYPES = {
  potluck:  { label: 'Potluck',      color: '#D97F4A', soft: '#FBEFE6', tint: '#FBEFE6', glyph: '◔', icon: UtensilsCrossed, sub: 'Dish coordination' },
  worship:  { label: 'Worship',      color: '#4A7EC4', soft: '#E3EAF8', tint: '#E3EAF8', glyph: '◉', icon: Music,            sub: 'Prayer · concert' },
  study:    { label: 'Bible Study',  color: '#C29A3D', soft: '#F7F0DC', tint: '#F7F0DC', glyph: '◇', icon: BookOpen,         sub: 'Topic · scripture' },
  social:   { label: 'Social',       color: '#C75D8A', soft: '#F8E6EE', tint: '#F8E6EE', glyph: '○', icon: Coffee,           sub: 'Casual gathering' },
  outdoors: { label: 'Outdoors',     color: '#5B8B6B', soft: '#E8F0EA', tint: '#E8F0EA', glyph: '△', icon: TreePine,         sub: 'Hike · sport · trail' },
  kids:     { label: 'Kids & Youth', color: '#D4A843', soft: '#F8F1DC', tint: '#F8F1DC', glyph: '☆', icon: Star,             sub: 'VBS · camp · youth' },
  service:  { label: 'Service',      color: '#7C5CD3', soft: '#EFEAF8', tint: '#EFEAF8', glyph: '✦', icon: HeartHandshake,   sub: 'Volunteer outreach' },
} as const

export type EventTypeKey = keyof typeof EVENT_TYPES

export function getEventType(key: string) {
  return EVENT_TYPES[key as EventTypeKey] ?? EVENT_TYPES.potluck
}

export const EVENT_TYPE_IMAGES: Record<string, string> = {
  potluck:  'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=180&h=180&q=70',
  worship:  'https://images.unsplash.com/photo-1507692049790-de58290a4334?auto=format&fit=crop&w=180&h=180&q=70',
  study:    'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?auto=format&fit=crop&w=180&h=180&q=70',
  social:   'https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&w=180&h=180&q=70',
  outdoors: 'https://images.unsplash.com/photo-1551632811-561732d1e306?auto=format&fit=crop&w=180&h=180&q=70',
  kids:     'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?auto=format&fit=crop&w=180&h=180&q=70',
  service:  'https://images.unsplash.com/photo-1559027615-cd4628902d4a?auto=format&fit=crop&w=180&h=180&q=70',
}

export const GRADIENT = 'linear-gradient(135deg, #3B4CCA 0%, #7C5CD3 100%)'
